import React from "react";
import { Grid } from "@material-ui/core";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import "date-fns";
// components
import PageError from '../PageError';
import PageLoading from '../PageLoading';
import { useQuery } from '@apollo/react-hooks';
import { GET_REPORT_BY_DATE } from "../../queries/reports";
import { momentFormat } from "../Utils/formatters";
var moment = require('moment')

let mainChartData = [];
let options = {};

export default function PublisherChartAndGrid(props) {
  var { initialDate, endDate, networkPublishers, isDashboard } = props;

  const { data: dataByDate, loading, error } = useQuery(GET_REPORT_BY_DATE, {
    variables: { dateStart: moment(initialDate).format(momentFormat), dateEnd: moment(endDate).format(momentFormat), 
      publishers: networkPublishers },
  });

  if(dataByDate)
  {
    mainChartData = dataByDate.reportByDate;
    options = 
    { 
      title: { text: 'Chart' }, xAxis: { title: { text: 'Date' }, 
      categories: mainChartData.map(item => item.date ? moment(item.date).add(1, 'days').format('YYYY-MM-DD') : 'null')
    },
    legend: { align: 'center', verticalAlign: 'bottom', x: 0, y: 0 },
    tooltip: { xDateFormat: '%d/%m/%Y', shared: true, split: false, enabled: true },  
    responsive: {
      rules: [{ condition: { maxWidth: 500 },
          chartOptions: { legend: { layout: 'horizontal', align: 'center', verticalAlign: 'bottom' } }
      }]},
    series: [ { name: 'IMPRESSIONS', data: mainChartData.map(item => item.impressions ? item.impressions : 0) },
    { name: 'REVENUE', data: mainChartData.map(item => item.revenue ? item.revenue : 0) }] };  

    if(isDashboard !== true)
    {
      options.series.push(
        { name: 'CTR', data: mainChartData.map(item => item.ctr ? item.ctr : 0) }, 
        { name: 'CPM', data: mainChartData.map(item => item.cpm ? item.cpm : 0) },
        { name: 'VIEWABILITY', data: mainChartData.map(item => item.viewability ? item.viewability : 0) }
      )
    }
    
  }
  
  return (
    <> 
    <Grid item xs={12}>
        {(loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
          />
        )}
        </Grid>
    </>
  );
}